<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">新增</span>
      </div>
    </div>
    <Form :label-width="100">
      <Row>
        <FormItem label="标题">
          <Input
            v-model="formItem.title"
            placeholder="请输入标题"
            style="width: 300px"
          ></Input>
        </FormItem>
        <FormItem label="详情">
          <vue-editor
            v-model="formItem.content"
            useCustomImageHandler
            @imageAdded="handleImageAdded"
          ></vue-editor>
        </FormItem>
        <FormItem label="附件">
          <Upload style="width: 300px" type="drag" :action="baseUrl + '/print/uploadOriginalName'"  multiple
            :on-success="uploadSuccess" :on-error="uploadError" :on-remove="uploadRemove" :default-file-list="fileList">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>点击或拖拽上传</p>
            </div>
            </Upload>
        </FormItem>
      </Row>
      <FormItem label>
        <Button @click="$router.back()">取消</Button>
        <Button type="success" @click="save" :loading="loading" style="margin:0 20px;">保存</Button>
        <Button type="error" @click="top" :loading="loading">{{formItem.is_first==0?'置顶':'取消置顶'}}</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { VueEditor } from 'vue2-editor'
import config from '@/config'

export default {
  components: { VueEditor },
  data () {
    return {
      baseUrl: '',
      formItem: {
        title: '',
        content: '',
        file_list: '',
        is_first: 0
      },
      fileList: [],
      uploadList: [],
      loading: false
    }
  },
  methods: {
    ...mapActions(['GetNoticeDetail', 'EditNotice', 'ImagesUpload']),
    getData () {
      this.GetNoticeDetail({ id: this.formItem.id }).then((res) => {
        this.formItem = res.data
        if (res.data.file_list) {
          this.fileList = res.data.file_list.split(',').map((item, index) => {
            return {
              name: this.getFilenameFromUrl(item),
              url: item
            }
          })
        }
      })
    },
    handleImageAdded (file, Editor, cursorLocation) {
      if (file.size > 800 * 1024) {
        this.$Message.warning({
          content: `图片过大(${file.name}),为避免用户加载时间过长,推荐裁剪后再编辑`,
          duration: 5
        })
        return false
      }
      var formData = new FormData()
      formData.append('file', file)
      this.ImagesUpload(formData).then((res) => {
        if (res.code === 1) Editor.insertEmbed(cursorLocation, 'image', res.path)
      })
    },

    uploadSuccess (response, file, fileList) {
      console.log('上传地址', response, fileList)
      this.uploadList = fileList
    },
    uploadError (e) {
      this.$Message.warning({
        content: `文件上传失败`,
        duration: 5
      })
    },
    uploadRemove (file, fileList) {
      this.fileList = fileList
      console.log('删除文件', this.fileList)
    },
    save () {
      this.loading = true
      console.log('文件列表：', this.fileList)

      this.formItem.file_list = ''
      let array = this.uploadList.concat(this.fileList)
      if (array.length > 0) {
        array.forEach((item) => {
          if (item.response) {
            this.formItem.file_list += item.response + ','
          }
          if (item.url) {
            this.formItem.file_list += item.url + ','
          }
        })
        let index = this.formItem.file_list.lastIndexOf(',')
        if (index !== -1) {
          this.formItem.file_list = this.formItem.file_list.substr(0, this.formItem.file_list.length - 1)
        }
      } else {
        this.formItem.file_list = null
      }
      console.log(this.formItem)
      this.EditNotice(this.formItem).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (!res.status) {
          return false
        }
        setTimeout(() => {
          this.$router.back()
        }, 1500)
      })
    },
    // 置顶
    top () {
      this.formItem.is_first = this.formItem.is_first == 1 ? 0 : 1
      this.save()
    },
    // 从URL中提取文件名
    getFilenameFromUrl (url) {
      var index = url.lastIndexOf('/')
      if (index > -1) {
        return decodeURIComponent(url.substring(index + 1))
      }
      return decodeURIComponent(url)
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.formItem.id = this.$route.query.id
    }
    if (this.formItem.id && this.formItem.id > 0) this.getData()
  },
  created () {
    this.baseUrl =
      process.env.NODE_ENV === 'development'
        ? config.baseUrl.dev
        : config.baseUrl.pro
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
